import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import {TaskService} from '../services/task.service';
import {TableComponent} from '../views/table/table.component';
import {NewTableComponent} from '../views/new-table/new-table.component';
import {CalendarComponent} from '../views/calendar/calendar.component';
import {Subscription} from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import {DatePipe} from '@angular/common';
import {UtilsModule} from '../utils/utils.module';
import {NewCalendarComponent} from '../views/new-calendar/new-calendar.component';
import {TreeTableComponent} from '../views/tree-table/tree-table.component';
import * as XLSX from 'xlsx';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { myRxStompConfig } from '../utils/stomp.config';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
export interface BoardAttributeType {
  boardId?: string;
  boardDateType?: string;
  boardView?: string;
}
export interface BoardConfig {
  boardUser?: object;
}
@Component({
  selector: 'nf-task-panel',
  templateUrl: './task-panel.component.html',
  styleUrls: ['./task-panel.component.css'],
  providers: [DatePipe]
})
export class TaskPanelComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSubscription: Subscription = null;
  @ViewChild('taskTable') taskTable: TableComponent;
  @ViewChild('newTaskTable') newTaskTable: NewTableComponent;
  @ViewChild('taskCalendar') taskCalendar: CalendarComponent;
  @ViewChild('newTaskCalendar') newTaskCalendar: NewCalendarComponent;
  @ViewChild('treeTable') treeTable: TreeTableComponent;
  @Output() linkChange: EventEmitter<any> = new EventEmitter();
  @Output() refreshList: EventEmitter<any> = new EventEmitter<any>();
  @Input('boardAttribute') set AttrChange(val: BoardAttributeType) {
    if (val) {
      this.boardAttribute = val;
      this.boardId = this.boardAttribute.boardId;
      if (this.boardAttribute.boardView === 'tree-table') {
        if (!this.boardAttribute.boardDateType) {
          this.boardAttribute.boardDateType = '1';
        }
      }
      if (this.boardAttribute.boardView === 'maintable') {
        if (!this.boardAttribute.boardDateType) {
          this.boardAttribute.boardDateType = '0';
        }
      }
      this.taskStatusList = [];
      this.getBoardList();
    }
  }
  boardId = null; // 存放面板ID
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  defaultView: any = {
    'icon': 'icon-calendar',
    'title': '表格视图',
    'code': 'maintable'
  }; // 存放当前视图
  // 状态初始色块
  statusInit = [
    {
      index: 1,
      label: '进行中',
      color: 'rgb(253, 171, 61)'
    },
    {
      index: 2,
      label: '完成',
      color: 'rgb(0, 200, 117)'
    },
    {
      index: 3,
      label: '已停止',
      color: 'rgb(226, 68, 92)'
    },
    {
      index: 4,
      label: '等待审核',
      color: 'rgb(87, 155, 252)'
    },
    {
      index: 5,
      label: '',
      color: 'rgb(0, 140, 140)'
    },
    {
      index: 6,
      label: '',
      color: 'rgb(255, 100, 46)'
    },
    {
      index: 7,
      label: '',
      color: 'rgb(0, 134, 192)'
    },
    {
      index: 8,
      label: '',
      color: 'rgb(162, 93, 220)'
    },
    {
      index: 9,
      label: '',
      color: 'rgb(127, 83, 71)'
    },
    {
      index: 10,
      label: '',
      color: 'rgb(255, 90, 196)'
    },
    {
      index: 11,
      label: '',
      color: 'rgb(255, 21, 138)'
    },
    {
      index: 12,
      label: '',
      color: 'rgb(187, 51, 84)'
    },
    {
      index: 13,
      label: '',
      color: 'rgb(3, 127, 76)'
    },
    {
      index: 14,
      label: '',
      color: 'rgb(255, 203, 0)'
    },
    {
      index: 15,
      label: '',
      color: 'rgb(202, 182, 65)'
    },
    {
      index: 16,
      label: '',
      color: 'rgb(156, 211, 38)'
    },
    {
      index: 17,
      label: '',
      color: 'rgb(51, 51, 51)'
    },
    {
      index: 18,
      label: '',
      color: 'rgb(120, 75, 209)'
    },
    {
      index: 19,
      label: '',
      color: 'rgb(102, 204, 255)'
    },
    {
      index: 20,
      label: '',
      color: 'rgb(128, 128, 128)'
    }
  ];
  searchKey;
  isIntegrationVisible = false;
  isAutomationVisible = false;
  linkType = 'archive'; // 归档
  isMemberVisible: boolean; // 选择成员弹窗
  selectedMemberValue = null; // 成员选择绑定
  subscribersCounter: string; // 成员数量
  isPermissionVisible = false; // 面板权限弹窗
  selectedPermissionValue = null; // 面板权限选中项
  boardMenuVisible = false; // 面板菜单POP
  selectedPermissionVisible = false; // 面板权限下拉POP
  selectedPermissionEditVisible = false; // 面板权限下拉POP
  permissionDescription: string; // 面板权限描述
  selectedPermissionId: string; // 面板权限ID
  selectedPermissionDropdownValue: Array<any> = []; // 面板权限下拉选中
  isPermissionConfirmLoading = false; // 面板权限按钮状态
  permissionType = 'view'; // 面板权限类型
  permissionDefinition: any; // 存放面板权限配置
  currentUser: any; // 存放当前用户信息
  selectIndex = 0;
  boardPermissionData: any; // 存放面板权限
  addNewGroupVisible = false;
  importModalVisible = false;
  excelData = []; // 解析excel得到的数据
  excelTitleData = [];
  excelColumnData = [];
  excelColumnMapping = [];
  excelTaskColumn;
  excelCheckbox = true;
  excelGroupName;
  excelImportStep = 0;
  excelSupportColumns = ['text', 'date', 'date-time', 'time-interval', 'status', 'multiple-person', 'dropdown', 'select'];
  importDataLoading = false;
  importData;
  importButtonDisabled = true;
  overTip = false;
  isSpinning = false;
  taskChangeDate = new Date();
  messageSubscription: Subscription;
  userId: string;
  taskParameters: any; // 任务中心系统参数
  taskButtonColumnId: string;
  taskHandleColumnId: string;
  boardAttribute: BoardAttributeType;
  // 高级查询
  advancedQueryForm!: FormGroup;
  taskStatusList = [];
  queryLoading = false;
  boardConfigInfo: BoardConfig;
  constructor(
    private taskService: TaskService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private utilsModule: UtilsModule,
    private modal: NzModalService,
    private datePipe: DatePipe,
    private rxStompService: RxStompService,
    private permissionsService: NgxPermissionsService
  ) { }

  ngOnInit() {
    localStorage.setItem('statusInit', JSON.stringify(this.statusInit));
    const taskDataDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    localStorage.setItem('taskDataDate', taskDataDate);
    this.permissionDescription = '面板成员权限设置';
    this.advancedQueryForm = this.fb.group({
      nameFuzzy: [null],
      periodStartAt: [null],
      periodEndAt: [null],
      taskProgressValue: [[]]
    });
    // 订阅websocket
    setTimeout( () => {
      const profile = localStorage.getItem('profile');
      if (profile && profile !== 'null') {
        this.userId = JSON.parse(profile).userId;
      }
      const url = '/message/response/task/create';
      const _url = '/message/response/task/update_cell_value';
      this.messageSubscription = this.rxStompService.watch(url).subscribe((msg: any) => {
        console.log('creat：');
        if (msg.body) {
          const _msg = JSON.parse(msg.body);
          console.log(_msg);
          if (_msg.content && _msg.content.newData) {
            this.getBoardList();
          }
        }
      });
      this.messageSubscription = this.rxStompService.watch(_url).subscribe((msg: any) => {
        console.log('update：');
        if (msg.body) {
          const body = JSON.parse(msg.body);
          const content = JSON.parse(body.content.value);
          console.log(content);
          this.handleWsMsg(this.boardPulseData, content);
        }
      });
    }, 1000);
  }
  ngAfterViewInit() {
    this.getSysParamsData();
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }
  // 获取面板数据
  getBoardList() {
    this.isSpinning = true;
    this.taskHandleColumnId = null;
    this.taskButtonColumnId = null;
    if (localStorage.getItem('defaultView') && localStorage.getItem('defaultView') !== 'null') {
      this.defaultView.code = localStorage.getItem('defaultView');
    }
    if (this.boardAttribute.boardDateType === '1') {
      let params = {};
      const param = this.datePipe.transform(this.taskChangeDate, 'yyyy-MM-dd');
      params = {
        periodAt: param
      };
      this.dataSubscription = this.taskService.queryDateTaskPanel(this.boardId, params).subscribe((res) => {
        this.isSpinning = false;
        if (res) {
          this.handleResponseData(res);
        }
      }, () => {
        this.isSpinning = false;
        this.message.error('查询数据异常');
      });
    } else if (this.boardAttribute.boardDateType === '0') {
      this.dataSubscription = this.taskService.getBoardData(this.boardId).subscribe((res: any) => {
        this.isSpinning = false;
        if (res) {
          this.handleResponseData(res);
        }
      }, () => {
        this.isSpinning = false;
      });
    }
  }

  // 查询面板数据
  search() {
    const params = {
      searchKey: this.searchKey ? this.searchKey : ''
    };
    if (this.boardAttribute.boardDateType === '1') {
      params['periodAt'] = this.datePipe.transform(this.taskChangeDate, 'yyyy-MM-dd');
    }
    this.isSpinning = true;
    this.dataSubscription = this.taskService.queryTaskPanel(this.boardId, params).subscribe((res) => {
      this.isSpinning = false;
      if (res) {
        this.handleResponseData(res);
      } else {
        this.message.error('查询数据异常');
      }
    }, () => {
      this.isSpinning = false;
    });
  }
  // 按日期查询面板数据
  searchDate(param) {
    const params = {
      periodAt: param
    };
    this.isSpinning = true;
    this.dataSubscription = this.taskService.queryDateTaskPanel(this.boardId, params).subscribe((res) => {
      this.isSpinning = false;
      if (res) {
        this.handleResponseData(res);
      } else {
        this.message.error('查询数据异常');
      }
    }, () => {
      this.message.error('查询数据异常');
      this.isSpinning = false;
    });
  }

  handleResponseData(res) {
    this.boardData = res;
    this.boardGroupData = this.boardData.boardData.groups;
    this.boardColumnData = this.boardData.boardData.columns;
    this.boardPulseData = this.boardData.boardData.pulses;
    this.boardId = this.boardData.id;
    this.subscribersCounter = this.boardData.subscribersCounter;
    this.permissionDefinition = this.boardData.permissionDefinition;
    this.currentUser = this.boardData.boardData.currentUser;
    this.defaultView.code = this.boardData.views;
    localStorage.setItem('defaultView', this.boardData.views);
    this.setViews(this.boardData.views);
    // load permissions
    this.permissionsService.loadPermissions(this.currentUser.permissions);
    // 保存当前面板登录人到本地
    this.boardConfigInfo = {
      boardUser: this.currentUser
    };
    localStorage.setItem('boardConfigInfo', JSON.stringify(this.boardConfigInfo));
    // 保存分配人到本地存储
    localStorage.setItem('local_user', JSON.stringify(this.boardData.boardData.users));
    // 状态标签组件增加默认值
    this.excelColumnData = [];
    this.boardColumnData.forEach((colums, index) => {
      let count = 0;
      if (colums.type === 'status') {
        for (let i = 0; i < colums.labels.length; i++) {
          if (colums.labels[i].index === 0) {
            count = count + 1;
          }
        }
        if (count === 0) {
          if (colums.type === 'status') {
            const o = {
              'color': 'rgb(196, 196, 196)',
              'index': 0,
              'label': ''
            };
            colums.labels.push(o);
          }
        }
      }
      if (colums.type !== 'name') {
        this.excelColumnData.push(colums);
      }
      if (colums.type === 'taskButton') {
        this.taskButtonColumnId = colums.id;
      }
      if (colums.type === 'handler') {
        this.taskHandleColumnId = colums.id;
      }
      if (colums.type === 'taskProgress') {
        this.taskStatusList = colums.labels ? colums.labels : [];
        this.taskStatusList.push({index: -1, label: '空'});
      }
    });
    const userPermissions = this.currentUser.permissions as Array<string>;
    if (!userPermissions.includes('owner')) {
      for (const p of userPermissions) {
        // 如果当前用户只有只读权限， 禁止复制页面内容
        if (p && (p.includes('viewer') || p.includes('view_only'))) {
          document.onkeydown = function (e) {
            const keyCode = e.key;
            const ctlKey = e.ctrlKey ;
            if (ctlKey && keyCode === 'c') {
              document.getSelection().empty();
            }
          };
          break;
        }
      }
    }
  }

  // 添加分组
  addNewGroup(viewCode) {
    this.addNewGroupVisible = false;
    this.boardMenuVisible = false;
    switch (viewCode) {
      case 'maintable':
        this.taskTable.addNewGroup(this.boardId);
        break;
      case 'new-table':
        this.newTaskTable.addNewGroup(this.boardId);
        break;
      case 'calendar':
        this.taskCalendar.addNewGroup(this.boardId);
        break;
      case 'new-calendar':
        this.newTaskCalendar.addNewGroup(this.boardId);
        break;
      case 'tree-table':
        this.treeTable.addNewGroup(this.boardId);
        break;
    }
  }
  // 切换视图
  changeView(val) {
    this.setViews(val);
    const param = {
      views: val
    };
    this.dataSubscription = this.taskService.updateBoardViews(this.boardId, param).subscribe(() => {
      // this.getBoardList();
    });
  }
  // 设置视图
  setViews(val) {
    switch (val) {
      case 'maintable':
        this.defaultView = {
          'icon': 'icon-biaoge',
          'title': '表格视图',
          'code': val
        };
        break;
      case 'new-table':
        this.defaultView = {
          'icon': 'icon-biaoge',
          'title': '表格视图(新)',
          'code': val
        };
        break;
      case 'calendar':
        this.defaultView = {
          'icon': 'icon-calendar',
          'title': '日历视图',
          'code': val
        };
        break;
      case 'new-calendar':
        this.defaultView = {
          'icon': 'icon-calendar',
          'title': '日历视图(新)',
          'code': val
        };
        break;
      case 'tree-table':
        this.defaultView = {
          'icon': 'icon-calendar',
          'title': '日志视图',
          'code': val
        };
        break;
    }
  }
  // 集成弹窗
  handleIntegrationOpen() {
    this.isIntegrationVisible = true;
  }
  handleIntegrationCancel() {
    this.isIntegrationVisible = false;
  }
  // 自动化弹窗
  handleAutomationOpen() {
    this.isAutomationVisible = true;
  }
  handleAutomationCancel() {
    this.isAutomationVisible = false;
  }
  // 切换到归档面板
  changeLinkStatus() {
    this.boardMenuVisible = false;
    this.linkChange.emit(this.linkType);
  }
  // 归档任务面板
  archiveBoard() {
    this.boardMenuVisible = false;
    this.dataSubscription = this.taskService.doDeleteBoard(this.boardId, {}).subscribe((res: any) => {
      this.message.create('success', '归档成功！');
      this.refreshList.emit();
      this.clearLocalStorage();
    });
  }
  lockGroupTitle(titleLock) {
    this.taskService.setTitleLock(this.boardId, titleLock).subscribe(res => {
      if (res) {
        this.boardData.titleLock = titleLock;
      }
    });
  }
  // 清除本地存储
  clearLocalStorage() {
    if (localStorage.getItem('borardId')) {
      localStorage.removeItem('borardId');
    }
    if (localStorage.getItem('borardName')) {
      localStorage.removeItem('borardName');
    }
  }
  // 接受状态更新面板数据
  updateTable(event) {
    if (event) {
      this.getBoardList();
    }
  }
  // 选择成员
  openSelectMember() {
    this.isMemberVisible = true;
  }
  // 选择成员弹窗事件
  handleMemberOk() {
    this.isMemberVisible = false;
  }
  handleMemberCancel() {
    this.isMemberVisible = false;
    // this.message.info('权限更新，数据重新加载中...');
    this.getBoardList();
  }
  // 设置面板权限
  setBoardPermissions() {
    this.boardMenuVisible = false;
    this.isPermissionVisible = true;
    this.selectIndex = 0;
    this.selectedPermissionId = '';
    this.permissionType = 'view';
    this.selectedPermissionDropdownValue = [];
    this.getBoardPermissionData();
    this.getBoardList();
  }
  // 关闭面板权限
  handlePermissionCancel() {
    this.isPermissionVisible = false;
  }
  // 面板权限提交
  handlePermissionOk() {
    if (this.selectedPermissionId === 'edit_by_assignee' || this.selectedPermissionId === 'view_by_assignee') {
      if (!this.selectedPermissionDropdownValue || this.selectedPermissionDropdownValue.length === 0) {
        this.message.warning('请选择人员列');
        return;
      }
    }
    this.isPermissionConfirmLoading = true;
    const param = {
      'permission': this.selectedPermissionId,
      'type': this.permissionType,
      'assigneeColumnIds': Array.from(new Set(this.selectedPermissionDropdownValue))
    };
    this.dataSubscription = this.taskService.addBoardPermission(this.boardId, param).subscribe((res: any) => {
      this.isPermissionConfirmLoading = false;
      this.isPermissionVisible = false;
      this.message.create('success', '设置成功！');
    }, (err) => {
      this.isPermissionConfirmLoading = false;
    });
  }
  // 获取面板权限列表
  getBoardPermissionData() {
    this.dataSubscription = this.taskService.getBoardPermission(this.boardId).subscribe((res: any) => {
      this.boardPermissionData = res;
      if (this.boardPermissionData) {
        if ((this.boardPermissionData.hasOwnProperty('view') && this.boardPermissionData.view) && (this.boardPermissionData.hasOwnProperty('edit') && this.boardPermissionData.edit)) {
          this.selectIndex = 0;
          this.selectedPermissionId = this.boardPermissionData.view.permission;
          this.selectedPermissionValue = this.boardPermissionData.view.permission;
          this.selectedPermissionDropdownValue = this.boardPermissionData.view.assigneeColumnIds;
        } else {
          if (this.boardPermissionData.hasOwnProperty('view') && this.boardPermissionData.view) {
            this.selectIndex = 0;
            this.selectedPermissionId = this.boardPermissionData.view.permission;
            this.selectedPermissionValue = this.boardPermissionData.view.permission;
            this.selectedPermissionDropdownValue = this.boardPermissionData.view.assigneeColumnIds;
          }
          if (this.boardPermissionData.hasOwnProperty('edit') && this.boardPermissionData.edit) {
            this.selectIndex = 1;
            this.selectedPermissionId = this.boardPermissionData.edit.permission;
            this.selectedPermissionValue = this.boardPermissionData.edit.permission;
            this.selectedPermissionDropdownValue = this.boardPermissionData.edit.assigneeColumnIds;
          }
        }
      }
    });
  }
  // 面板权限选中回调
  selectedPermissionChange(event) {
    if (event) {
      this.selectedPermissionId = event;
    }
    if (this.permissionType === 'edit' && this.selectedPermissionValue !== 'edit_by_assignee') {
      this.selectedPermissionDropdownValue = [];
    }
  }
  // 面板权限列下拉选中
  permissionDropdownChange(event) {
    this.selectedPermissionDropdownValue = event;
  }
  // 获取当前TAB
  getTabSelectIndex(event) {
    this.selectedPermissionDropdownValue = [];
    if (event === 0) {
      this.permissionType = 'view';
      this.selectIndex = 0;
      if (this.boardPermissionData.view) {
        this.selectedPermissionId = this.boardPermissionData.view.permission;
        this.selectedPermissionValue = this.boardPermissionData.view.permission;
        this.selectedPermissionDropdownValue = this.boardPermissionData.view.assigneeColumnIds;
      } else {
        this.selectedPermissionId = '';
        this.selectedPermissionValue = '';
        this.selectedPermissionDropdownValue = [];
      }
    } else {
      this.permissionType = 'edit';
      this.selectIndex = 1;
      if (this.boardPermissionData.edit) {
        this.selectedPermissionId = this.boardPermissionData.edit.permission;
        this.selectedPermissionValue = this.boardPermissionData.edit.permission;
        this.selectedPermissionDropdownValue = this.boardPermissionData.edit.assigneeColumnIds;
      } else {
        this.selectedPermissionId = '';
        this.selectedPermissionValue = '';
        this.selectedPermissionDropdownValue = [];
      }
    }
  }

  exportBoardToExcel(withUpdates: boolean) {
    const param = {
      searchKey: this.searchKey,
      withUpdates: withUpdates
    };
    this.taskService.exportBoardToExcel(this.boardId, param).subscribe(result => {
      if (result) {
        const link = document.createElement('a');
        const blob = new Blob([result], {type: 'application/octet-stream'});
        link.href = window.URL.createObjectURL(blob);
        link.download = this.getFileName() + '.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.message.error('数据请求失败');
      }
    });
  }

  exportExcelWithInfoBox() {
    const param = {
      searchKey: this.searchKey
    };
    this.taskService.exportExcelWithInfoBox(this.boardId, param).subscribe(result => {
      if (result) {
        const link = document.createElement('a');
        const blob = new Blob([result], {type: 'application/octet-stream'});
        link.href = window.URL.createObjectURL(blob);
        link.download = this.getFileName() + "_" + new Date().getMilliseconds() + '.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.message.error('数据请求失败');
      }
      this.boardMenuVisible = false;
    });
  }

  getFileName(): string {
    let fileName;
    const date = new Date();
    if (this.boardData) {
      fileName = this.boardData['name'] + this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    } else {
      fileName = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    }
    return fileName;
  }

  showImportDataModal() {
    this.excelImportStep = 0;
    this.addNewGroupVisible = false;
    this.importModalVisible = true;
    this.importButtonDisabled = true;
    this.overTip = false;
  }

  // excel文件上传处理
  handleFileUpload() {
    this.importButtonDisabled = true;
    this.excelCheckbox = true;
    this.excelTaskColumn = null;
    this.excelData = [];
    this.excelTitleData = [];
    this.excelColumnMapping = [];
    const fileInput = document.getElementById('excel-upload-input');
    fileInput.click();
    fileInput.onchange = () => {
      const files = fileInput['files'];
      const fileName = files[0].name as string;
      this.excelGroupName = fileName.substring(0, fileName.lastIndexOf('.'));
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {type: 'array'});
        const sheetName: string = workbook.SheetNames[0];
        const ws = workbook.Sheets[sheetName];
        this.excelData = XLSX.utils.sheet_to_json(ws, {header: 1, blankrows: false, raw: false});
        // 如果没有数据或只有一行一列，错误提示
        if (!this.excelData || this.excelData.length === 0) {
          this.message.warning('文件内容为空，无法导入该表格数据！');
        } else {
          // 处理空数据
          let columnLength = 0;
          for (const row of this.excelData) {
            if (row.length > columnLength) {
              columnLength = row.length;
            }
          }
          for (const row of this.excelData) {
            const rowLength = columnLength - row.length;
            for (let i = 0; i < rowLength; i++) {
              row.push('');
            }
          }
          this.excelTitleData = this.excelData[0];
          for (let i = 0; i < this.excelTitleData.length; i++) {
            this.excelColumnMapping.push({
              title: this.excelTitleData[i],
              activated: false,
              column: null
            });
          }
          this.excelImportStep = 1;
        }
      };
      reader.readAsArrayBuffer(files[0]);
    };
  }

  excelTaskColumnChange() {
    this.importButtonDisabled = !(this.excelTaskColumn || this.excelTaskColumn === 0);
  }

  mappingColumnChange(target, index) {
    target.activated = true;
    for (let i = 0; i < this.excelColumnMapping.length; i++) {
      if (target.column === this.excelColumnMapping[i].column && index !== i) {
        this.excelColumnMapping[i].activated = false;
        this.excelColumnMapping[i].column = null;
        break;
      }
    }
  }

  importDataToNewGroup() {
    this.importDataLoading = true;
    const param = {
      title: this.excelGroupName,
      color: this.utilsModule.getRandomColor(),
      nameIndex: this.excelTaskColumn,
      titleInclude: this.excelCheckbox,
      columnMappings: this.excelColumnMapping,
      data: this.excelData
    };
    this.taskService.importDataToGroup(this.boardId, param).subscribe(res => {
      if (res) {
        this.taskTable.nfUpdateTable.emit(true);
      } else {
        this.message.error('导入失败，请稍后重试');
      }
      this.importModalVisible = false;
      this.importDataLoading = false;
    });
  }
  // 刷新面板
  refreshBoard() {
    this.getBoardList();
  }
  // 任务日期切换
  onChange(event) {
    if (event) {
      const param = this.datePipe.transform(this.taskChangeDate, 'yyyy-MM-dd');
      localStorage.setItem('taskDataDate', param);
      this.searchDate(param);
    } else {
      this.taskChangeDate = null;
      localStorage.setItem('taskDataDate', null);
      this.getBoardList();
    }
  }
  onDateRangeChange(event) {
    this.getBoardList();
  }
  handleWsMsg(data, content) {
    data.forEach(pulse => {
      if (pulse.children && pulse.children.length) {
        this.handleWsMsg(pulse.children, content);
      } else {
        if (pulse.id === content.pulseId && content.columnType === 'taskAbnormalStatistics') {
          pulse.columnValues[content.columnId] = {
            indicatorItemStatistic: content[content.columnId].indicatorItemStatistic,
            auditItemStatistic: content[content.columnId].auditItemStatistic
          };
        }
        if (pulse.id === content.pulseId && content.columnType === 'taskExecuteTime') {
          pulse.columnValues[content.columnId] = content[content.columnId];
        }
        if (pulse.id === content.pulseId && content.columnType === 'taskProgress') {
          pulse.columnValues[content.columnId] = content[content.columnId];
          if (this.taskButtonColumnId) {
            pulse.columnValues[this.taskButtonColumnId] = {
              scanStatus: 'success'
            };
          }
          if (this.taskHandleColumnId) {
            const sysUser = {
              id: 'systemUser',
              name: '系统用户'
            };
            pulse.columnValues[this.taskHandleColumnId] = {
              personsAndTeams: [sysUser]
            };
            const param = {};
            param['pulseIds'] = [pulse.id];
            param['columnId'] = this.taskHandleColumnId;
            param['columnValue'] = pulse.columnValues[this.taskHandleColumnId];
            this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
          }
        }
      }
    });
  }
  // 获取任务系统参数
  getSysParamsData() {
    this.taskService.getSysParams().subscribe(res => {
      if (res) {
        this.taskParameters = res;
      }
    });
  }

  sortBoard(data: any) {
    console.log(data);
    const boardId = data.id;
    let sort = data.sort;
    if (!sort) {
      sort = 'asc';
    } else if (sort === 'asc') {
      sort = 'desc';
    } else {
      sort = null;
    }
    const param = {sort: sort};
    this.taskService.updateBoardSort(boardId, param).subscribe(res => {
      this.getBoardList();
    });
  }
  // 高级查询
  submitAdvancedQueryForm() {
    if (this.advancedQueryForm.valid) {
      this.queryLoading = true;
      this.datePipe.transform(this.taskChangeDate, 'yyyy-MM-dd');
      const params = {};
      if (this.advancedQueryForm.get('nameFuzzy').value) {
        params['nameFuzzy'] = this.advancedQueryForm.get('nameFuzzy').value;
      }
      if (this.advancedQueryForm.get('periodStartAt').value) {
        params['periodStartAt'] = this.datePipe.transform(this.advancedQueryForm.get('periodStartAt').value, 'yyyy-MM-dd');
      }
      if (this.advancedQueryForm.get('periodEndAt').value) {
        params['periodEndAt'] = this.datePipe.transform(this.advancedQueryForm.get('periodEndAt').value, 'yyyy-MM-dd');
      }
      if (this.advancedQueryForm.get('taskProgressValue').value) {
        params['taskProgressValue'] = this.advancedQueryForm.get('taskProgressValue').value.join(',');
      }
      this.dataSubscription = this.taskService.queryDateTaskPanel(this.boardId, params).subscribe((res) => {
        this.queryLoading = false;
        this.isSpinning = false;
        if (res) {
          this.handleResponseData(res);
        }
      }, () => {
        this.isSpinning = false;
        this.queryLoading = false;
      });
    } else {
      Object.values(this.advancedQueryForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  cancelAdvancedQueryForm() {
    this.advancedQueryForm.reset();
  }
}
